export const CHAIN_ID = process.env.NEXT_PUBLIC_CHAIN_ID
export const NAME_NETWORK = process.env.NEXT_PUBLIC_NAME_NETWORK
